<script lang="ts">
  import { uniq } from "lodash-es";
  import { searchFilter, updateSearchFilter } from "state/page";
  import {usageDomains} from "bildebanken-model";
  $: selected = $searchFilter?.usageDomains ?? [];
  function onChange(this: HTMLInputElement & { value: string }) {
    if (this.checked) {
      updateSearchFilter("usageDomains", uniq(selected.concat(this.value)));
    } else {
      updateSearchFilter(
        "usageDomains",
        selected.filter((v) => v !== this.value),
      );
    }
  }
</script>

<button type="button">Bruksområde</button>
<bb-expand hidden={!selected.length}>
  <div class="sources">
    {#each usageDomains as usageDomain}
      <label>
        <input
          type="checkbox"
          class="org-input"
          checked={selected.includes(usageDomain.value)}
          on:change={onChange}
          value={usageDomain.value}
        />
        {usageDomain.name}
      </label>
    {/each}
  </div>
</bb-expand>

<style>
  /** Alignment is off with default values, but shouldn't need this much tweaking */
  .sources {
    display: flex;
    flex-direction: column;
    gap: var(--org-xsmall);
  }
</style>
